export default __webpack_public_path__ + "static/media/message.d460947c.svg";